export const BBI_CORE_ENROLLMENT_SHORT_NAMES = {
	HP: "Health Plan",
	CC: "Clinic Card",
	GSTD: "Group Short Term Disability",
	"GLTD 1": "Group Long Term Disability(Class 1)",
	"GLTD 2": "Group Long Term Disability(Class 2)",
	HOO: "Helping Our Own",
	KSOP: "KSOP",
	GLI: "Group Life Insurance",
	CCE: "Christmas Club Election"
};

export const BBI_VEB_ENROLLMENT_SHORT_NAMES = {
	Cancer: "Cancer",
	"Whole Life": "Whole life",
	STD: "Short Term Disability",
	"Critical Illness": "Critical Illness",
	HI: "Hospital Indemnity",
	Accident: "Accident",
	GLI: "Group Life Indemnity",
	FPP: "Family Protection",
	"Doc & Rx": "Doc and Rx",
	Vision: "Vision",
	Dental: "Dental"
};
